import { Dispatch, SetStateAction } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { IUserData } from "../../interfaces/forms";

import useToast from "../useToast";

import cookiesHelper from "../../helpers/cookies";
import api from "../apiClient";

export interface IPayload {
    payload: IUserData[];
    setIsProcessing: Dispatch<SetStateAction<boolean>>;
};

export interface IResponse {
    error?: any;
    message: string;
    statusCode: number;
};

const useSaveUsers = () => {
    const queryClient = useQueryClient();

    const { addToast } = useToast();

    const mutationFn = async (data: IPayload): Promise<IResponse> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`


        const res = await api.post(`users/save`, data.payload);
        return res.data;
    };

    return useMutation({
        mutationFn,
        onMutate: (variables: IPayload) => {
            variables.setIsProcessing(true);
        },
        onSuccess: (response: IResponse, variables: IPayload) => {
            if (response) {
                addToast({
                    type: 'success',
                    title: 'Users saved successfully.',
                });

                queryClient.invalidateQueries({ queryKey: ['schools_tree'] });
                queryClient.invalidateQueries({ queryKey: ['users'] });
            };
        },
        onError: (error: any, variables: IPayload) => {
            addToast({
                type: 'error',
                title: 'Error occured',
                message: error?.response?.data?.message || 'Error occured.'
            });
        },
        onSettled: (data: IResponse | undefined, error: any, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useSaveUsers;